module.exports = __webpack_public_path__ + "img/flicker_red2.cc85ef96.gif";